import React from 'react'
import { useStyletron } from 'styletron-react'
import { merchantTheme } from 'theme'

type Props = {
  children: React.ReactNode
}

// Shared card chrome for the RecoveryAI case-detail and Reports order-rating
// detail panels. The remaining inline copies (OverviewTab, RecentActivitiesTable,
// RatingDetail) migrate onto this across PRs #3983–#3984. Renamed (not `Card`)
// to avoid colliding with scenes/Home/Metrics/Card — same reasoning as
// FeedbackResolvedByCell.
const DetailPanel = ({ children }: Props) => {
  const [css] = useStyletron()

  const cardClass = css({
    border: `1px solid ${merchantTheme.colors.grey20}`,
    borderRadius: '4px',
    padding: '24px',
    backgroundColor: 'white',
    marginBottom: '16px',
  })

  return <div className={cardClass}>{children}</div>
}

export default DetailPanel
